<ol-header
  [platformUrl]="platformUrl"
  [app]="appId"
  [featureFlags]="flagsSnapshot()"
  [applicationAccess]="applicationAccess()"
>
  <!-- Mark and name both come from the kit APPS registry, so the header logo, the tab
       icon and the OL-Hub switcher tile can never disagree. Never project local artwork
       here — that is the drift this replaced. -->
  <ol-app-logo appLogo [app]="appId" />

  <div center class="search-bar-on-header-container hub-d-flex hub-align-items-center hub-w-100">
    @if (shouldSearchBarBeVisible() && !isLicensePortal()) {
      <hub-main-header-searchbar class="hub-w-100" />
    }
  </div>

  <hub-main-header-actions end />
</ol-header>
